import { Component, OnInit } from '@angular/core';
import { CommonService } from '../common.service';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AlertService } from 'ngx-alerts'; 
import { SessionStorageService } from 'ngx-webstorage';
import { AirdropService } from './airdrop.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ValidationsService } from '../validations.service';

@Component({
  selector: 'app-airdrop',
  templateUrl: './airdrop.component.html',
  styleUrls: ['./airdrop.component.css']
})
export class AirdropComponent implements OnInit {
airdropForm: any;
  constructor(private  commonService: CommonService, private formBuilder: FormBuilder,private spinner: NgxSpinnerService, private session: SessionStorageService,private routes: Router, private alertService: AlertService, private airdropService: AirdropService) { 
    this.airdropForm = this.formBuilder.group({
      'ethaddr': ['', Validators.required],
      'availablebal': ['', Validators.required],
      'transferamt': ['', Validators.required]
    },{validator: ValidationsService.validateBalance });
  }

  ngOnInit() {
    this.airdropService.getDetails().then((res: any)  => {
       this.spinner.hide();
      this.airdropForm.controls.availablebal.patchValue(res.availabletoken);
  }).catch((err: any) => {     
    this.spinner.hide();
});
    if(this.session.retrieve('token')){
      this.commonService.tokenValidity().then((res: any) => {
        this.spinner.hide();
        }).catch((err: any) => {     
            this.alertService.danger(err.message);
            this.spinner.hide();
            this.routes.navigate(['/login']);
      });
    }else{      
      this.routes.navigate(['/login']);
    }
  }

  submit() {
    if(!this.airdropForm.valid){
      Object.keys(this.airdropForm.controls).forEach(field => { 
        const control = this.airdropForm.get(field);           
        control.markAsDirty({ onlySelf: true }); 
      });
      return;
    }
    this.spinner.show();
      this.airdropService.check(this.airdropForm.value.ethaddr,this.airdropForm.value.transferamt).then((res: any) => {
        this.spinner.hide();
        // this.alertService.success(res.message);
        if(res.status == 'success'){
          this.alertService.success(res.message);
          this.routes.navigate(['main/airdropotp']);
        }else{
          this.spinner.hide();
          this.routes.navigate(['main/airdrop']);
        }
      }).catch((err: any) => {this.alertService.danger(err.message)
      });
  }
}
